import { useState } from 'react';
import { UserService } from '../modules/configuracoes/usuario/Service';
import { useAppContext } from '../contexts/AppContext';
import { ChevronLeft } from 'lucide-react';

const service = new UserService();

export default function RecoverPassword({ setRecoverPass }: any) {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);

    const { errorSnackbar, successSnackbar } = useAppContext();

    const onSubmitRequest = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setLoading(true);

        try {
            await service.requestRecoverPassword(email);
            successSnackbar('Email enviado com instruções para restaurar senha!');
            setRecoverPass(false);
        } catch (error: any) {
            errorSnackbar('Ocorreu um erro ao tentar recuperar a senha.');
        } finally {
            setLoading(false);
        }
    };

    return <form className="space-y-4 md:space-y-6" onSubmit={onSubmitRequest} key={1}>
        <div className="flex items-center text-white" onClick={() => setRecoverPass(false)}>
            <button
                type="button"
                className="btn btn-xs btn-circle mr-2 border-white/10 bg-white/[0.08] text-white hover:bg-white/[0.14]"
            >
                <ChevronLeft aria-hidden="true" />
            </button>
            Recuperar Senha
        </div>
        <div>
            <label htmlFor="email" className="block mb-2 text-sm font-medium text-slate-200">
                Email
            </label>
            <input
                type="email"
                name="email"
                id="email"
                disabled={loading}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input input-bordered w-full rounded-2xl border-white/10 bg-white/[0.06] text-white placeholder:text-slate-500 focus:border-amber-300 focus:outline-none"
                placeholder="name@company.com"
                required
            />
        </div>
        <button
            type="submit"
            disabled={loading}
            className="btn w-full rounded-2xl border-0 bg-[linear-gradient(135deg,#d97706_0%,#facc15_100%)] text-[#241506] shadow-[0_0_40px_-18px_rgba(245,158,11,0.85)] hover:scale-[1.01] hover:bg-[linear-gradient(135deg,#d97706_0%,#facc15_100%)] disabled:opacity-60"
        >
            {loading ? <span className="loading loading-spinner loading-sm" /> : 'Continuar'}
        </button>
    </form>;
}
